<cass-core-toolbar></cass-core-toolbar>
<div class='page-container'>
	<mat-card class="branding--title-card">
		<mat-card-content>
			<div class="title-card">
				<h1>
					{{ (isNewLine ? "ORDER_LINE.NEW_ORDER_LINE" : "ORDER_LINE.EDIT_ORDER_LINE") | translate }}
				</h1>
				<div class="title-card-details">
					<mat-icon>person</mat-icon>
					<div>{{ originalOrder?.orderHeader?.advertiserName }}</div>
				</div>
			</div>
		</mat-card-content>
	</mat-card>
	<div class="accordion-container">
		<mat-accordion>
			<mat-expansion-panel [expanded]="selectionStep === 0" (opened)="selectionPanelExpanded(0)">
				<mat-expansion-panel-header>
					<div class="expansion-panel-header-container">
						<div class="expansion-panel-header-title">{{ "ORDER_LINE.PRODUCTS_PANEL_TITLE" | translate }}</div>
						<mat-chip-listbox *ngIf="selectedPackagesIds.size">
							<mat-chip>{{ selectedPackagesIds.size }}</mat-chip>
						</mat-chip-listbox>
						<div class="expansion-panel-header-text">{{ selectedPackagesLabels }}</div>
					</div>
				</mat-expansion-panel-header>
				<div class="product-filters-container">
					<div class="product-search-box dense-component-container">
						<mat-form-field subscriptSizing="dynamic">
							<mat-icon matPrefix>search</mat-icon>
							<input matInput placeholder="{{ 'ORDER_LINE.PRODUCT_FILTER_SEARCH_BY_TITLE' | translate }}" [(ngModel)]="filterProductName">
						</mat-form-field>
					</div>
					<div class="product-filter"
						 *ngFor="let filter of productFilters | keyvalue:productFilterSortFn"
						 [ngClass]="{ 'product-filter-drop-down': filter.value.controlType === 1 }">
						<ng-container *ngIf="filter.value.controlType === 1; else toggleButtons">
							<mat-label>{{ filter.key }}</mat-label>
							<mat-form-field class="product-search-box dense-component-container"
											subscriptSizing="dynamic">
								<mat-select [(ngModel)]="filter.value.selected" placeholder="{{filter.key}}">
									<mat-option>
										<ngx-mat-select-search placeholderLabel="Search"
															   noEntriesFoundLabel="No records found!"
															   [(ngModel)]="filter.value.searchQuery">
										</ngx-mat-select-search>
									</mat-option>
									<mat-option value="">{{ "ORDER_LINE.PRODUCT_FILTER_OPTION_ALL" | translate }}</mat-option>
									<mat-option *ngFor="let option of filter.value.options | sortByKeyAndReturnValues:localeId | cassFilter : filter.value.searchQuery" [value]="option">
										{{ option }}
									</mat-option>
								</mat-select>
							</mat-form-field>
						</ng-container>
						<ng-template #toggleButtons>
							<mat-label>{{ filter.key }}</mat-label>
							<mat-button-toggle-group [(ngModel)]="filter.value.selected">
								<mat-button-toggle value="">{{ "ORDER_LINE.PRODUCT_FILTER_OPTION_ALL" | translate }}</mat-button-toggle>
								<mat-button-toggle *ngFor="let option of filter.value.options | sortByKeyAndReturnValues:localeId" value="{{ option }}">
									{{ option }}
								</mat-button-toggle>
							</mat-button-toggle-group>
						</ng-template>
					</div>
					<div class="product-filters-actions-container">
						<button mat-button (click)="resetProductsFilters()">{{ "ORDER_LINE.PRODUCTS_RESET_FILTERS" | translate }}</button>
					</div>
				</div>
				<div>
					<button mat-button (click)="uiSelectFilteredProducts()">{{ "ORDER_LINE.PRODUCTS_SELECT_ALL" | translate }}</button>
					<button mat-button *ngIf="selectedPackagesIds.size" (click)="uiClearAllProducts()">{{ "ORDER_LINE.PRODUCTS_CLEAR_ALL" | translate }}</button>
				</div>
				<div class="static-item-list-container">
					<ng-container *ngFor="let productVM of productsVMs">
						<div class="static-item" *ngIf="showFilteredProduct(productVM) && (productVM.isValid || productVM.isSelected)" [ngClass]="{ 'invalid': !productVM.isValid }">
							<mat-checkbox [checked]="productVM.isSelected" (change)="uiToggleProduct(productVM)" (mouseenter)="onProductMouseEnter(productVM.id, $event)" (mouseleave)="onProductMouseLeave(productVM.id, $event)">
								{{ productVM.label }}
							</mat-checkbox>
							<div class="invalid-selection-message">
								<mat-icon>remove_circle</mat-icon>
								<div>{{ "ORDER_LINE.PRODUCT_NOT_VALID_FOR_PLACEMENT_SIZE" | translate }}</div>
							</div>
						</div>
					</ng-container>
				</div>
			</mat-expansion-panel>

			<mat-expansion-panel [expanded]="selectionStep === 1" (opened)="selectionPanelExpanded(1)">
				<mat-expansion-panel-header>
					<div class="expansion-panel-header-container">
						<div class="expansion-panel-header-title">{{ "ORDER_LINE.SIZE_PANEL_TITLE" | translate }}</div>
						<div class="expansion-panel-header-text">{{ selectedSizeLabel }}</div>
					</div>
				</mat-expansion-panel-header>
				<div class="static-item-list-container">
					<ng-container *ngFor="let sizeVM of sizesVMs">
						<div class="static-size-item" *ngIf="sizeVM.isValid || sizeVM.isSelected" [ngClass]="{ 'invalid': !sizeVM.isValid }">
							<div class="static-size-page-pair">
								<div class="static-size-page">
									<div class="static-size-shape" [ngStyle]="{ 'width': sizeVM.widthRatio * 100 + '%', 'height': sizeVM.depthRatio * 100 + '%' }">
									</div>
								</div>
								<div class="static-size-page" *ngIf="sizeVM.widthRatio > 1"></div>
							</div>
							<mat-checkbox [checked]="sizeVM.isSelected" (change)="uiToggleSize(sizeVM)">
								{{ sizeVM.label }}
							</mat-checkbox>
							<div class="invalid-selection-message">
								<mat-icon>remove_circle</mat-icon>
								<div>{{ "ORDER_LINE.SIZE_NOT_VALID_FOR_PRODUCT_PLACEMENT" | translate }}</div>
							</div>
						</div>
					</ng-container>
				</div>
			</mat-expansion-panel>

			<mat-expansion-panel [expanded]="selectionStep === 2" (opened)="selectionPanelExpanded(2)">
				<mat-expansion-panel-header>
					<div class="expansion-panel-header-container">
						<div class="expansion-panel-header-title">{{ "ORDER_LINE.PLACEMENT_PANEL_TITLE" | translate }}</div>
						<div class="expansion-panel-header-text">{{ selectedPlacementLabel }}</div>
					</div>
				</mat-expansion-panel-header>
				<div class="static-item-list-container">
					<ng-container *ngFor="let placementVM of placementsVMs">
						<div class="static-item" *ngIf="placementVM.isValid || placementVM.isSelected" [ngClass]="{ 'invalid': !placementVM.isValid, 'placement-requires-approval': placementVM.requiresApproval }">
							<mat-checkbox [checked]="placementVM.isSelected" (change)="uiTogglePlacement(placementVM)">
								{{ placementVM.label }}
							</mat-checkbox>
							<div class="invalid-selection-message">
								<mat-icon>remove_circle</mat-icon>
								<div>{{ "ORDER_LINE.PLACEMENT_NOT_VALID_FOR_PRODUCT_SIZE" | translate }}</div>
							</div>
						</div>
					</ng-container>
				</div>
				<div class="placement-requires-approval-legend" *ngIf="showPlacementApprovalLegend">{{ "ORDER_LINE.PLACEMENT_REQUIRES_PUBLISHER_APPROVAL" | translate }}</div>
				<div><mat-form-field class="placement-request-form-field"><mat-label>{{ "ORDER_LINE.PLACEMENT_REQUEST_FIELD_LABEL" | translate }}</mat-label><input matInput [formControl]="placementRequest"></mat-form-field></div>
			</mat-expansion-panel>

			<mat-expansion-panel [expanded]="selectionStep === 3" (opened)="selectionPanelExpanded(3)">
				<mat-expansion-panel-header>
					<div class="expansion-panel-header-container">
						<div class="expansion-panel-header-title">{{ "ORDER_LINE.DATES_PANEL.TITLE" | translate }}</div>
						<ng-container *ngIf="insertionCounter">
							<mat-chip-listbox>
								<mat-chip>{{ "ORDER_LINE.DATES_PANEL.DATE_COUNT" | translate:{ count: dateCounter } }}</mat-chip>
								<mat-chip>{{ "ORDER_LINE.DATES_PANEL.INSERTION_COUNT" | translate:{ count: insertionCounter } }}</mat-chip>
							</mat-chip-listbox>
							<div class="expansion-panel-header-text"><a class="clear-button" (click)="clearAllDates();$event.stopPropagation();false">{{ "ORDER_LINE.DATES_PANEL.CLEAR_ACTION" | translate }}</a></div>
						</ng-container>
					</div>
				</mat-expansion-panel-header>
				<div>
					<!-- <mat-calendar #calendar1 (selectedChange)='calendar_selectedChange($event)' [dateClass]='dateClass' [minDate]='minDate' [maxDate]='maxDate'></mat-calendar> -->
					<!-- <mat-calendar #calendar2 (selectedChange)='calendar_selectedChange($event)' [dateClass]='dateClass' [minDate]='minDate' [maxDate]='maxDate'></mat-calendar> -->
					<!-- <mat-calendar #calendar3 (selectedChange)='calendar_selectedChange($event)' [dateClass]='dateClass' [minDate]='minDate' [maxDate]='maxDate'></mat-calendar> -->
				</div>
				<div *ngIf="isMatrixVisible">
					<mat-progress-bar mode="determinate" value="{{ spaceAvailabilityRequestProgressValue }}" class="cass-space-availability-progress-bar"></mat-progress-bar>
					<cass-multi-pub-issues-matrix [pubsAndIssues]="matrixPubsAndIssues" (toggleDate)="uiToggleDate($event)"></cass-multi-pub-issues-matrix>
				</div>
				<div class="date-panel-empty-message-container" *ngIf="!isMatrixVisible">
					{{ "ORDER_LINE.DATES_PANEL.EMPTY_PANEL_MESSAGE" | translate }}
				</div>
			</mat-expansion-panel>

		</mat-accordion>

	</div>

	<mat-card class="branding--section-card">
		<mat-card-content class="expansion-panel-header-container">
			<!-- <div class="expansion-panel-header-title">{{ "ORDER_LINE.PRICE_PANEL.TITLE" | translate }}</div> -->
			<div class="fields-container-row">
				<div class="field"><div class="data-panel-field-label">{{ "ORDER_BASKET.ORDER_LINE_TABLE_COLUMNS.GROSS_PRICE" | translate }}</div> <div class="data-panel-field-value">{{ priceGross | cassCurrency }}</div></div>
				<div class="field"><div class="data-panel-field-label">{{ "ORDER_BASKET.ORDER_LINE_TABLE_COLUMNS.DISCOUNTS" | translate }}</div> <div class="data-panel-field-value">{{ discount | cassCurrency }}</div></div>
				<div class="field" *ngIf="!isDirectOrder"><div class="data-panel-field-label">{{ "ORDER_BASKET.ORDER_LINE_TABLE_COLUMNS.NET_EX_COMMISSION" | translate }}</div> <div class="data-panel-field-value">{{ priceNetExComm | cassCurrency }}</div></div>
				<div class="field" *ngIf="!isDirectOrder"><div class="data-panel-field-label">{{ "ORDER_BASKET.ORDER_LINE_TABLE_COLUMNS.COMMISSION" | translate }}</div> <div class="data-panel-field-value">{{ commission | cassCurrency }}</div></div>
				<div class="field net-price"><div class="data-panel-field-label">{{ "ORDER_BASKET.ORDER_LINE_TABLE_COLUMNS.NET_PRICE" | translate }}</div> <div class="data-panel-field-value">{{ priceNet | cassCurrency }}</div></div>
				<!-- <div><button mat-icon-button color="primary" class="edit-button"><mat-icon>edit</mat-icon></button></div> -->
			</div>
		</mat-card-content>
	</mat-card>

	<mat-card class='footer branding--action-card button-container'>
		<mat-card-content>
			<button mat-raised-button color='primary' (click)="okAction()" [disabled]="!canApply">{{ "ACTION_BUTTON_LABELS.APPLY" | translate }}</button>
			<button mat-stroked-button (click)="cancelAction()">{{ "ACTION_BUTTON_LABELS.DISCARD_CHANGES" | translate }}</button>
		</mat-card-content>
	</mat-card>

</div>
